import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TablePagination,
  TextField,
  Button,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {  Modal } from '../ui';

interface TestCaseSegmentModalProps {
    showConfirmationModal: string;
    testCaseSegmentNames: string[]; // ✅ proper typing here
    testCaseSegmentCount: number;
    confirm: () => void;
  }

  const TestCaseSegmentCountModal: React.FC<TestCaseSegmentModalProps> = ({ showConfirmationModal, testCaseSegmentNames = [], testCaseSegmentCount = 0, confirm }) => {
  const [showFullTable, setShowFullTable] = useState(false);
  const [page, setPage] = useState(0);
  const rowsPerPage = 10;
  const [searchQuery, setSearchQuery] = useState('');

  const filteredRows = testCaseSegmentNames.filter(name =>
    name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  const paginatedRows = filteredRows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

  return (
    <>
      {/* Main Confirmation Modal */}
      <Modal
        isOpen={showConfirmationModal}
        title="Are you sure you want to Edit?"
        small
        body={
          <div>
            <p>Are you sure you want to edit this segment?</p>
            <p>This segment is used in other test cases.</p>

            {testCaseSegmentCount > 0 && (
              <div style={{ marginTop: 12 }}>
                <strong>Number of Test Cases using this Segment:</strong> {testCaseSegmentCount}

                <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: 8 }}>
                  <Button size="small" style={{ color: '#006a68'}} onClick={() => setShowFullTable(true)}>Expand Table</Button>
                </div>

                <div
                  style={{
                    maxHeight: 200,
                    overflowY: 'auto',
                    marginTop: 8,
                    border: '1px solid #ccc',
                    borderRadius: 4,
                  }}
                >
                  <Table
                    size="small"
                    stickyHeader
                    sx={{
                      '& .MuiTableCell-root': {
                        padding: '4px 8px',
                        fontSize: '0.75rem !important',
                      },
                    }}
                  >
                    <TableHead>
                      <TableRow>
                        <TableCell><strong>#</strong></TableCell>
                        <TableCell><strong>Test Case Name</strong></TableCell>
                        <TableCell><strong>Count</strong></TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {testCaseSegmentNames.slice(0, 5).map((nameWithCount, index) => {
                        const match = nameWithCount.match(/(.*) \((\d+)\)$/);
                        const name = match?.[1] || nameWithCount;
                        const count = match?.[2] || '-';
                        return (
                          <TableRow key={index}>
                            <TableCell>{index + 1}</TableCell>
                            <TableCell>{name}</TableCell>
                            <TableCell>{count}</TableCell>
                          </TableRow>
                        );
                      })}
                    </TableBody>
                  </Table>
                </div>
              </div>
            )}
          </div>
        }
        ButtonDelete={confirm}
        deleteConfirmation
      />

      {/* Fullscreen Expanded Table Dialog */}
      <Dialog
        open={showFullTable}
        onClose={() => {
          setShowFullTable(false);
          setPage(0);
          setSearchQuery('');
        }}
        fullWidth
        maxWidth="md"
        scroll="paper"
        
      >
        <DialogTitle
            sx={{
                background: '#006a68 !important',
                color: '#fff !important',
                fontSize: '16px !important',
              }}
        >
          Test Cases using this Segment
          <IconButton
            aria-label="close"
            onClick={() => setShowFullTable(false)}
            sx={{ position: 'absolute', right: 8, top: 8 }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <DialogContent dividers>
          <TextField
            label="Search Test Case"
            variant="outlined"
            size="small"
            fullWidth
            value={searchQuery}
            onChange={(e) => {
              setSearchQuery(e.target.value);
              setPage(0);
            }}
            sx={{ marginBottom: 2 }}
          />

          <Table
            size="small"
            sx={{
              '& .MuiTableCell-root': {
                padding: '6px 12px',
                fontSize: '16px !important',
              },
            }}
          >
            <TableHead 
              >
              <TableRow>
                <TableCell>#</TableCell>
                <TableCell>Test Case Name</TableCell>
                <TableCell>Count</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {paginatedRows.map((nameWithCount, index) => {
                const match = nameWithCount.match(/(.*) \((\d+)\)$/);
                const name = match?.[1] || nameWithCount;
                const count = match?.[2] || '-';
                return (
                  <TableRow key={index}>
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    <TableCell>{name}</TableCell>
                    <TableCell>{count}</TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </DialogContent>

        <div style={{ overflow: 'unset' }}>
        <TablePagination
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={(event, newPage) => setPage(newPage)}
            rowsPerPageOptions={[10]}
            sx={{ overflow: 'unset' }} // Prevent internal overflow
        />
        </div>
      </Dialog>
    </>
  );
};

export default TestCaseSegmentCountModal;
